module.exports = "https://cdn.redage.net/src/views/player/help/images/airdrop2.jpg";